import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initApm } from "@/shared/utils/apm";
import { App } from "@/partner/app/App";
import { installPreloadErrorReload } from "@/partner/app/preloadError";
import { installBackNavigationListener } from "@/partner/shared/hooks";

initApm({
  serverUrl: import.meta.env.VITE_PARTNER_ELASTIC_APM_SERVER_URL,
  serviceName: import.meta.env.VITE_PARTNER_ELASTIC_APM_SERVICE_NAME,
});

installPreloadErrorReload(window);
// Раньше роутера: слушатели popstate на window вызываются в порядке
// регистрации, а вопрос о несохранённых правках должен успеть до того,
// как роутер закроет диалог (см. shared/hooks/unsavedChangesGuard.ts).
installBackNavigationListener(window);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
